import {ParsedTabsResponse as Base} from '@mintdata-wsp/common/controllers/network/generated/responses/ParsedTabsResponse';
import {Workbook} from '@mintdata-wsp/common/controllers/network/extended/responses/Workbook';

export class ParsedTabsResponse extends Base
{
    public readonly workbook:Workbook;

    constructor(json:any)
    {
        super(json);

        this.workbook = json['workbook']? new Workbook(json['workbook']):null;
    }
}
